import { useEffect, useState } from 'react';

/**
 * Custom hook to track an individual value, and run an error check function against it every time the value is modified
 */
const useValChecker = (initialValue, errorFunc, checkOnMount = false) => {
  const [val, setVal] = useState(initialValue);
  const [error, setError] = useState('');
  const [mounted, setMounted] = useState(false);

  /* eslint-disable  react-hooks/exhaustive-deps */
  useEffect(() => {
    if (mounted || checkOnMount) {
      (async () => setError(await errorFunc(val)))();
    }
    setMounted(true);
  }, [val, errorFunc]);
  /* eslint-enable  react-hooks/exhaustive-deps */

  return [val, setVal, error, setError];
};

export default useValChecker;
